export default __webpack_public_path__ + "c76340df1fcf2878f4eabd3869970b2b.jpg";